import { Paragraph, Flex, DetailedIconCalculator, mediaMixin } from '@zillow/constellation';
import styled, { css } from 'styled-components';

const StyledDetailedIconCalculator = styled(DetailedIconCalculator)`
    display: none;
    ${mediaMixin(
        'lg',
        css`
            display: block;
        `
    )}
`;

const Header = () => (
    <Flex display="flex" flexDirection="row" alignItems="center">
        <StyledDetailedIconCalculator />
        <Flex display="flex" flexDirection="column" marginLeft="sm">
            <Paragraph fontType="bodyHeading">Calculate your budget</Paragraph>
            <Paragraph>
                Deciding how much you can comfortably spend on a home will help you prepare for your search.
            </Paragraph>
        </Flex>
    </Flex>
);

export default Header;
